import { HTMLSelect } from '../ui/html-select'
import React from 'react'
import { RoundingStrategy } from '../../util/contstants'

const options = [
    {
        value: RoundingStrategy.ALWAYS_ROUND_UP,
        name: 'Always Round Up',
    },
    {
        value: RoundingStrategy.ALWAYS_ROUND_DOWN,
        name: 'Always Round Down',
    },
    {
        value: RoundingStrategy.NORMAL_ROUNDING,
        name: 'Normal Rounding',
    },
    {
        value: RoundingStrategy.WEIGHTED_ROUNDING,
        name: 'Weighted Rounding',
    },
]

interface RoundingStrategySelectProps {
    onChange: any
    value: number
    disabled?: boolean
}

export const RoundingStrategySelect = ({
    onChange,
    value,
    disabled = false,
}: RoundingStrategySelectProps) => {
    return (
        <HTMLSelect onChange={onChange} value={value} disabled={disabled}>
            {options.map((item, i) => {
                return (
                    <option key={i} value={item.value}>
                        {item.name}
                    </option>
                )
            })}
        </HTMLSelect>
    )
}
